'use client'

import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/button'
import { IChildrenProps } from '@/typings/children-props'
import { cn } from '@/utils/styles/cn'

interface IExpandToggleButtonProps extends IChildrenProps {
    isExpanded: boolean
    onClick: () => void
}

/**
 * Shared "show more / show less" button for collapsible sections: the chevron
 * flips to signal inline expansion rather than navigation.
 */
export const ExpandToggleButton = ({ isExpanded, onClick, children }: IExpandToggleButtonProps) => {
    return (
        <div className="flex w-full items-center justify-center pt-6">
            <Button styleType="secondary" onClick={onClick}>
                {children}

                <ChevronDown
                    className={cn(
                        'size-4 shrink-0 transition-transform duration-200',
                        isExpanded && 'rotate-180'
                    )}
                />
            </Button>
        </div>
    )
}
